import {Injectable} from '@angular/core';
import {PageAccessInfo} from '../models/page-access-info';
import {Subject} from 'rxjs';
import {User, USER_PREFERENCE_KEY, UserPreference} from '../models/user';
import {SavedAdvancedFilter} from '@bmc-ux/adapt-angular/advanced-filtering/advanced-filter/advanced-filter.models';

@Injectable({
  providedIn: 'root'
})
export class PageAccessStorageService {
  private _pageAccessInfo: PageAccessInfo = null;

  private sourceOnPageAccessInfo$: Subject<PageAccessInfo> = new Subject<PageAccessInfo>();
  public onTogglePageAccessInfo = this.sourceOnPageAccessInfo$.asObservable();

  get pageAccessInfo(): PageAccessInfo {
    return this._pageAccessInfo;
  }

  set pageAccessInfo(pageAccessInfo: PageAccessInfo) {
    this._pageAccessInfo = {... pageAccessInfo};
  }

  get userInfo(): User {
    return this.pageAccessInfo && this.pageAccessInfo.user ? this.pageAccessInfo.user : null;
  }

  set userInfo(user: User) {
    this.pageAccessInfo.user = {...user};
  }

  set userPreference(userPreferences: UserPreference[]) {
    this.pageAccessInfo.user.userPreferences = [...userPreferences];
  }

  public togglePageAccessInfo(pageAccessInfo: PageAccessInfo): void {
    this.pageAccessInfo = pageAccessInfo;
    this.sourceOnPageAccessInfo$.next(this.pageAccessInfo);
  }
}
